const Bgellips = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="577"
      height="803"
      viewBox="0 0 577 803"
      fill="none"
    >
      <g filter="url(#filter0_f_429_211)">
        <ellipse
          cx="350"
          cy="388.5"
          rx="150"
          ry="214.5"
          fill="#EBB268"
          fill-opacity="0.6"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_429_211"
          x="0"
          y="-26"
          width="700"
          height="829"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="100"
            result="effect1_foregroundBlur_429_211"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default Bgellips;
